<template>
  <section>
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        Teachers Overview&nbsp;
      </h1>
      <report-overview />
      <v-card class="filter-report pa-4 mb-3 mt-3">
        <h2 class="pb-2">Teacher Report</h2>
        <v-row>
          <v-col sm="6" cols="12">
            <v-select
              dense
              :items="headers"
              v-model="selected"
              label="Choose reporting metrics"
              multiple
              return-object
              class="pr-3"
            >
              <template v-slot:selection="{ item }">
                <v-chip x-small>
                  <span>{{ item.text }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col sm="6" cols="12">
            <report-date-picker
              :prop-date-from="dateFrom"
              :prop-date-to="dateTo"
              @dateToSelected="dateToSelected"
              @dateFromSelected="dateFromSelected"
            />
          </v-col>
        </v-row>
        <report-data-table
          @csvExport="csvExport"
          :headers="selected"
          :items="items"
          :loading="loading"
        />
      </v-card>
    </v-container>
  </section>
</template>

<script>
import ReportOverview from '../ReportOverview'
import ReportDataTable from '../ReportDataTable'
import ReportDatePicker from '../ReportDatePicker'
import ReportsMixin from '../reports-mixin'
import FileMixin from '../file-mixin'
import { mapState } from 'vuex'

export default {
  components: {
    ReportOverview,
    ReportDataTable,
    ReportDatePicker
  },
  mixins: [ReportsMixin, FileMixin],
  async mounted() {
    this.loading = true
    this.type = 'teachers' // type is a mixin attribute
    await this.searchItems()
    this.loading = false
  },
  data() {
    return {
      modal: false,
      loading: false,
      items: [],
      list: null
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    selected: {
      get() {
        if (this.list) {
          return this.list
        } else {
          return [
            {
              text: 'Teacher ID',
              value: 'id'
            },
            {
              text: 'Teacher Name',
              value: 'name'
            },
            {
              text: 'School Name',
              value: 'school_name'
            },
            {
              text: 'No. of Classes',
              value: 'custom_class_count',
              align: 'center'
            },
            {
              text: 'Assigned workshops',
              value: 'workshops_name',
              align: 'center'
            },
            {
              text: 'No. of Students',
              value: 'invitations_count',
              align: 'center'
            },
            {
              text: `No. of Assigned ${this.capitalizeFirstLetter(
                this.lessonTerm
              )}s`,
              value: 'lessons_count',
              align: 'center'
            }
          ]
        }
      },
      set(value) {
        this.list = value
      }
    },
    headers() {
      return [
        {
          text: 'Teacher ID',
          value: 'id'
        },
        {
          text: 'Teacher Name',
          value: 'name'
        },
        {
          text: 'No. of Classes',
          value: 'custom_class_count',
          align: 'center'
        },
        {
          text: 'No. of Students',
          value: 'invitations_count',
          align: 'center'
        },
        {
          text: `No. of Assigned ${this.capitalizeFirstLetter(
            this.lessonTerm
          )}s`,
          value: 'lessons_count',
          align: 'center'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.filter-report {
  width: 100%;

  h2 {
    display: block;
    width: 100%;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
